import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { useOpsProjects, getOpsProject } from "@/components/OpsProjectSelector";

let _cache = null;
export const projectsCache = () => _cache;

// Un registro sin proyecto no es válido cuando ya existe al menos un proyecto.
export const assertProject = (pid) => {
  if (_cache && _cache.length > 0 && !pid) { toast.warning("Selecciona el proyecto del registro"); return false; }
  return true;
};

export const defaultProject = () => getOpsProject();

// Campo "Proyecto" para cualquier formulario de captura. Se oculta si no hay proyectos.
export default function ProjectField({ value, onChange, testid = "project-field", className = "", compact = false }) {
  const projects = useOpsProjects();
  _cache = projects;
  return (
    <div className={className}>
      <Label className={compact ? "text-[10px] uppercase" : "overline-label"}>Depósito / Proyecto *</Label>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}
              className={`w-full ${compact ? "h-8" : "h-9"} border rounded-md px-2 text-sm bg-white ${!value ? "border-amber-400" : ""}`} data-testid={testid}>
        <option value="">— Elegir depósito / proyecto —</option>
        {projects.map((p) => <option key={p.id} value={p.id}>{p.code ? `${p.code} · ` : ""}{p.name}</option>)}
      </select>
      {projects.length === 0 && <p className="text-[10px] text-slate-500 mt-0.5">Sin proyectos aún: créalos en Ajustes › Proyectos de Operaciones.</p>}
    </div>
  );
}
